export default "__VITE_ASSET__BBM94Dfq__"